<template>
	<div class="omapi-courses">
		<div class="omapi-omu__section-header">
			<h3>Courses</h3>
			<a
				:href="marketingUrl('university/courses', 'University')"
				target="_blank"
				rel="noopener"
				@click="maybeUpsell"
			>
				View All Courses ({{ totalCourses }})
			</a>
		</div>
		<div class="omapi-courses__grid omapi-omu__grid omapi-card__flex">
			<core-loading v-if="isLoading" />
			<university-course v-for="course in courses" :key="course.id" :course="course" />
		</div>
	</div>
</template>

<script lang="js">
import { mapState } from 'vuex'
import { marketingSso } from '@/components/mixins/marketingSso'
import { upsell } from '@/university/mixins/upsell'

export default  {
	mixins : [ marketingSso, upsell ],
	data () {
		return {
			utmMedium : 'UniversityCourse',
		}
	},
	computed : {
		...mapState('omu', [ 'courses', 'totalCourses' ]),
		isLoading () {
			return this.$store.getters.isFetching('courses')
		},
	},
};
</script>
